import { Component } from '@angular/core';
import { environment } from '../../../../environments/environment';

/** Deviation from legacy (explicit new requirement, not a legacy-parity port): legacy's
 *  `environment-banner.component.html` only shows the banner on `*ngIf="configService.environment
 *  === 'STAGE'"`. This rewrite additionally shows it for `'DEV'` so local/dev builds are also
 *  visibly flagged as non-production; it remains hidden for `'PROD'` in both apps.
 *  Exported as a pure function for testability (same pattern as `isNotificationActive` in
 *  `UserNotificationBannerComponent`). */
export function isEnvironmentBannerVisible(environmentName: string): boolean {
  return environmentName === 'STAGE' || environmentName === 'DEV';
}

/**
 * Ports legacy `EnvironmentBannerComponent` — a striped "Test Environment" banner shown at the
 * top of every page. Deviation from legacy (explicit requirement): visible for BOTH `'DEV'` and
 * `'STAGE'` builds, hidden only for `'PROD'` (legacy shows it for `'STAGE'` only). Mounted once
 * in `DefaultLayoutComponent`, alongside `app-user-notification-banner` (same relative position
 * as legacy's `app.component.html`).
 */
@Component({
  selector: 'app-environment-banner',
  standalone: true,
  templateUrl: './environment-banner.component.html',
  styleUrl: './environment-banner.component.scss',
})
export class EnvironmentBannerComponent {
  readonly isVisible = isEnvironmentBannerVisible(environment.environmentName);

  /** Matches legacy's `*ngFor="let i of ' '.repeat(100).split('')"` — repeats the banner text
   * across the full width (a tiled/marquee fill), rather than a single centered label. */
  readonly repeatCount = Array.from({ length: 100 });
}
